import { render, staticRenderFns } from "./TrailBalancePage.vue?vue&type=template&id=5d0fc19c&scoped=true&"
import script from "./TrailBalancePage.vue?vue&type=script&lang=js&"
export * from "./TrailBalancePage.vue?vue&type=script&lang=js&"
import style0 from "./TrailBalancePage.vue?vue&type=style&index=0&id=5d0fc19c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0fc19c",
  null
  
)

export default component.exports